var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 70,
    viewBox: "0 0 62 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19C12 8.50659 20.5066 0 31 0C41.4934 0 50 8.50659 50 19V20.3001C56.8467 21.6899 62 27.7431 62 35V55C62 63.2843 55.2843 70 47 70H15C6.71573 70 0 63.2843 0 55V35C0 27.7431 5.15328 21.6899 12 20.3001V19ZM18 20H44V19C44 11.8203 38.1797 6 31 6C23.8203 6 18 11.8203 18 19V20ZM15 26C10.0294 26 6 30.0294 6 35V55C6 59.9706 10.0294 64 15 64H47C51.9706 64 56 59.9706 56 55V35C56 30.0294 51.9706 26 47 26H15ZM31 40C28.2386 40 26 42.2386 26 45C26 47.7614 28.2386 50 31 50C33.7614 50 36 47.7614 36 45C36 42.2386 33.7614 40 31 40ZM20 45C20 38.9249 24.9249 34 31 34C37.0751 34 42 38.9249 42 45C42 51.0751 37.0751 56 31 56C24.9249 56 20 51.0751 20 45Z",
    fill: "#618DFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLock);
export default __webpack_public_path__ + "static/media/icon-lock.a840b295ea39398cd51a798a983a2593.svg";
export { ForwardRef as ReactComponent };